// src/components/ShippingRecord/AddDisputePopin/DisputeFormAttachments.tsx
import React from "react";
import { useFormContext } from "react-hook-form";
import { Text } from "$components";
import CField, { CFieldInputProps } from "$forms/CField";
import FileUploader from "$components/FileUploader/FileUploader";
import { useStyles } from "../styles";
import { useDisputeForm } from "../context/DisputeFormContext";
import useJStyles from "$hooks/useJStyles";
import { EditMode } from "../hooks/useDisputeFormLogic";

export const DisputeFormAttachments: React.FC = () => {
  const {
    control,
    formState: { errors },
  } = useFormContext();
  const classes = useStyles();
  const { jclasses } = useJStyles();
  const { editMode, media } = useDisputeForm();

  return (
    <>
      <div className={jclasses.formSectionHead}>
        <Text type="h3">Documents</Text>
      </div>
      <div className={classes.lineContainer}>
        {editMode === EditMode.READ_ONLY && media?.length === 0 ? (
          <div className={classes.inputContainer}>
            Aucun document dans ce litige
          </div>
        ) : (
          <CField
            disabled={editMode === EditMode.READ_ONLY}
            name="media"
            control={control}
            error={errors.media}
          >
            {(props: CFieldInputProps) => (
              <FileUploader
                {...props}
                type="shipping"
                isLargeVersion
                isAdmin={editMode !== EditMode.READ_ONLY}
                isReadOnly={editMode === EditMode.READ_ONLY}
              />
            )}
          </CField>
        )}
      </div>
    </>
  );
};
